import { TableCell } from '@mui/material';
import { StatusIndicator } from 'app/common/components/sidebar';
import type React from 'react';
import styled from 'styled-components';
import type { StatusIndicatorCellStateProps } from './status-indicator-cell-container';

const TableStatusIndicator = styled(StatusIndicator)`
  margin: 0 auto;
`;
export type StatusIndicatorCellOwnProps = {
  readonly value: string;
};

export type StatusIndicatorCellProps = StatusIndicatorCellOwnProps & StatusIndicatorCellStateProps;

const StatusIndicatorCell: React.FC<StatusIndicatorCellProps> = (props: StatusIndicatorCellProps) => {
  return (
    <TableCell align="center" padding="none" width="64">
      <TableStatusIndicator title={props.title} bgcolor={props.color} />
    </TableCell>
  );
};

export default StatusIndicatorCell;
